export default __webpack_public_path__ + "static/media/hall_of_fame_one.10ff68d4.png";